import { AfterViewInit, Component } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CellClickedEvent } from 'ag-grid-community';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rapid-files-zoho',
  templateUrl: './rapid-files-zoho.component.html',
  styleUrls: ['./rapid-files-zoho.component.scss','../../underwritingdashboard/underwritingdashboard.component.scss']
})
export class RapidFilesZohoComponent implements AfterViewInit {

  subscribeFunded: any;
  subscribeIncomplete: any;
  subscribeAgreement: any;
  subscribeUnderwriting: any;
  subscribeApproved: any;

  rapidFunded: any;
  rapidFundedCount: any;
  rapidFundedAmount: number;

  rapidIncomplete: any
  rapidIncompleteCount: any
  rapidIncompleteAmount: number;

  rapidAgreement: any;
  rapidAgreementCount: any
  rapidAgreementAmount: number;

  rapidUnderwriting: any;
  rapidUnderwritingCount: any
  rapidUnderwritingAmount: number;

  rapidApproved: any;
  rapidApprovedCount: any
  rapidApprovedAmount: number;

  displayedColumns: string[] = ['Name', 'Agency', 'Collector', 'Creditor', 'Amount', 'Province', 'Created by', 'Created date'];

  spinner :boolean=true;
  constructor(private apiService: LegacyApiService, private router: Router) { }

  ngAfterViewInit(): void {
    this.getRapidFunded('Funded');
    this.getRapidIncomplete('Rapid - Incomplete Application');
    this.getRapidAgreement('Rapid - Agreement');
    this.getRapidUnderwriting('Rapid - Underwriting');
    this.getRapidApproved('Rapid Approved');
  }

  getRapidFunded(stage: string) {
    this.spinner = true;
    this.subscribeFunded = this.apiService.getRapidFilesZoho(stage).subscribe(((res: any) => {
      this.rapidFunded = res?.message;
      this.rapidFundedCount = this.rapidFunded.length;
      this.rapidFundedAmount = this.rapidFunded.map(item => item?.Amount).reduce((prev, next) => prev + next, 0).toFixed(2);
      // console.log(this.rapidFunded, this.rapidFundedAmount, "----------------Funded");
      this.spinner=false;
    }))
  }

  getRapidIncomplete(stage: string) {
    this.subscribeIncomplete = this.apiService.getRapidFilesZoho(stage).subscribe(((res: any) => {
      this.rapidIncomplete = res?.message;
      this.rapidIncompleteCount = this.rapidIncomplete.length;
      this.rapidIncompleteAmount = this.rapidIncomplete.map(item => item?.Amount).reduce((prev, next) => prev + next, 0).toFixed(2);
      // console.log(this.rapidIncomplete, "----------------Incomplete Application");
    }))
  }

  getRapidAgreement(stage: string) {
    this.subscribeAgreement = this.apiService.getRapidFilesZoho(stage).subscribe(((res: any) => {
      this.rapidAgreement = res?.message;
      this.rapidAgreementCount = this.rapidAgreement.length;
      this.rapidAgreementAmount = this.rapidAgreement.map(item => item?.Amount).reduce((prev, next) => prev + next, 0).toFixed(2);
      // console.log(this.rapidAgreement, "----------------Agreement");
    }))
  }

  getRapidUnderwriting(stage: string) {
    this.subscribeUnderwriting = this.apiService.getRapidFilesZoho(stage).subscribe(((res: any) => {
      this.rapidUnderwriting = res?.message;
      this.rapidUnderwritingCount = this.rapidUnderwriting.length;
      this.rapidUnderwritingAmount = this.rapidUnderwriting.map(item => item?.Amount).reduce((prev, next) => prev + next, 0).toFixed(2);
      // console.log(this.rapidUnderwriting, "----------------Agreement");
    }))
  }

  getRapidApproved(stage: string) {
    this.subscribeApproved = this.apiService.getRapidFilesZoho(stage).subscribe(((res: any) => {
      this.rapidApproved = res?.message;
      this.rapidApprovedCount = this.rapidApproved.length;
      this.rapidApprovedAmount = this.rapidApproved.map(item => item?.Amount).reduce((prev, next) => prev + next, 0).toFixed(2);
      // console.log(this.rapidApproved, "----------------rapidApproved");
    }))
  }

  ngOnDestroy() {
    this.subscribeFunded.unsubscribe();
    this.subscribeIncomplete.unsubscribe();
    this.subscribeAgreement.unsubscribe();
    this.subscribeUnderwriting.unsubscribe();
    this.subscribeApproved.unsubscribe();
  }

}
